import React from 'react';

const AnimatedBackground = () => {
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-0" style={{ top: '80px', bottom: '0' }}>
      <svg className="absolute w-full h-full" xmlns="http://www.w3.org/2000/svg">
        <defs>
          {/* Line-based Publishing Icons */}
          <g id="bookIcon">
            <rect x="-8" y="-10" width="16" height="20" stroke="#b45309" strokeWidth="1.5" fill="none" rx="1"/>
            <line x1="-8" y1="-3" x2="8" y2="-3" stroke="#b45309" strokeWidth="1"/>
            <line x1="-8" y1="2" x2="8" y2="2" stroke="#b45309" strokeWidth="1"/>
            <line x1="0" y1="-10" x2="0" y2="10" stroke="#b45309" strokeWidth="1"/>
          </g>
          
          <g id="penIcon">
            <path d="M 0 -12 L 0 10" stroke="#b45309" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
            <path d="M -2 -12 L 2 -12" stroke="#b45309" strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M 0 10 L -2 12 L 0 11 L 2 12 Z" stroke="#b45309" strokeWidth="1.5" fill="none" strokeLinejoin="round"/>
          </g>
          
          <g id="inkpotIcon">
            <circle cx="0" cy="0" r="6" stroke="#b45309" strokeWidth="1.5" fill="none"/>
            <rect x="-3" y="-8" width="6" height="8" stroke="#b45309" strokeWidth="1.5" fill="none"/>
            <line x1="-4" y1="-2" x2="4" y2="-2" stroke="#b45309" strokeWidth="1"/>
          </g>
          
          <g id="quillIcon">
            <path d="M 0 -12 Q -3 -6, -2 0" stroke="#b45309" strokeWidth="1.5" fill="none"/>
            <path d="M 0 -12 Q 3 -6, 2 0" stroke="#b45309" strokeWidth="1.5" fill="none"/>
            <line x1="0" y1="-10" x2="-4" y2="-4" stroke="#b45309" strokeWidth="0.8"/>
            <line x1="0" y1="-8" x2="-3" y2="-3" stroke="#b45309" strokeWidth="0.8"/>
          </g>
        </defs>

        {/* Line Path 1 - Horizontal flowing wave */}
        <g className="animate-line-1">
          <path 
            id="path1"
            stroke="#b45309"
            strokeWidth="2"
            strokeLinecap="round"
            strokeDasharray="8 12"
            d="M -200 150 Q 200 100, 600 200 T 1400 150 T 2200 200"
            fill="transparent"
          />
          <use href="#bookIcon" className="icon-motion">
            <animateMotion dur="28s" repeatCount="indefinite">
              <mpath href="#path1"/>
            </animateMotion>
          </use>
          <use href="#penIcon" className="icon-motion">
            <animateMotion dur="28s" repeatCount="indefinite" begin="9s">
              <mpath href="#path1"/>
            </animateMotion>
          </use>
        </g>

        {/* Line Path 2 - Diagonal swirl */}
        <g className="animate-line-2">
          <path 
            id="path2"
            stroke="#b45309"
            strokeWidth="2"
            strokeLinecap="round"
            strokeDasharray="8 12"
            d="M 1900 -100 Q 1600 100, 1300 300 Q 1000 500, 700 600 Q 400 700, 100 800"
            fill="transparent"
          />
          <use href="#quillIcon" className="icon-motion">
            <animateMotion dur="32s" repeatCount="indefinite">
              <mpath href="#path2"/>
            </animateMotion>
          </use>
          <use href="#inkpotIcon" className="icon-motion">
            <animateMotion dur="32s" repeatCount="indefinite" begin="11s">
              <mpath href="#path2"/>
            </animateMotion>
          </use>
        </g>

        {/* Line Path 3 - S curve */}
        <g className="animate-line-3">
          <path 
            id="path3"
            stroke="#b45309"
            strokeWidth="2"
            strokeLinecap="round"
            strokeDasharray="8 12"
            d="M -100 400 C 200 300, 400 500, 700 400 S 1200 300, 1500 400 S 1800 500, 2000 400"
            fill="transparent"
          />
          <use href="#bookIcon" className="icon-motion">
            <animateMotion dur="30s" repeatCount="indefinite">
              <mpath href="#path3"/>
            </animateMotion>
          </use>
          <use href="#penIcon" className="icon-motion">
            <animateMotion dur="30s" repeatCount="indefinite" begin="10s">
              <mpath href="#path3"/>
            </animateMotion>
          </use>
          <use href="#quillIcon" className="icon-motion">
            <animateMotion dur="30s" repeatCount="indefinite" begin="20s">
              <mpath href="#path3"/>
            </animateMotion>
          </use>
        </g>

        {/* Line Path 4 - Vertical wave */}
        <g className="animate-line-4">
          <path 
            id="path4"
            stroke="#b45309"
            strokeWidth="2"
            strokeLinecap="round"
            strokeDasharray="8 12"
            d="M 150 -200 Q 100 100, 200 400 Q 300 700, 150 1000 Q 0 1300, 150 1600"
            fill="transparent"
          />
          <use href="#bookIcon" className="icon-motion">
            <animateMotion dur="34s" repeatCount="indefinite">
              <mpath href="#path4"/>
            </animateMotion>
          </use>
        </g>

        {/* Line Path 5 - Bottom wave */}
        <g className="animate-line-5">
          <path 
            id="path5"
            stroke="#b45309"
            strokeWidth="2"
            strokeLinecap="round"
            strokeDasharray="8 12"
            d="M -200 700 Q 100 650, 400 750 T 1000 700 T 1600 750 T 2200 700"
            fill="transparent"
          />
          <use href="#inkpotIcon" className="icon-motion">
            <animateMotion dur="26s" repeatCount="indefinite">
              <mpath href="#path5"/>
            </animateMotion>
          </use>
          <use href="#quillIcon" className="icon-motion">
            <animateMotion dur="26s" repeatCount="indefinite" begin="8s">
              <mpath href="#path5"/>
            </animateMotion>
          </use>
        </g>
      </svg>

      <style jsx>{`
        /* Line animations with 15% max opacity */
        @keyframes lineFlow1 {
          0% {
            opacity: 0;
            transform: translateX(-100px) translateY(0);
          }
          15% {
            opacity: 0.15;
          }
          85% {
            opacity: 0.15;
          }
          100% {
            opacity: 0;
            transform: translateX(400px) translateY(-50px);
          }
        }

        @keyframes lineFlow2 {
          0% {
            opacity: 0;
            transform: translateX(100px) translateY(-100px);
          }
          20% {
            opacity: 0.15;
          }
          80% {
            opacity: 0.15;
          }
          100% {
            opacity: 0;
            transform: translateX(-250px) translateY(200px);
          }
        }

        @keyframes lineFlow3 {
          0% {
            opacity: 0;
            transform: translateX(-80px) translateY(50px);
          }
          18% {
            opacity: 0.15;
          }
          82% {
            opacity: 0.15;
          }
          100% {
            opacity: 0;
            transform: translateX(300px) translateY(120px);
          }
        }

        @keyframes lineFlow4 {
          0% {
            opacity: 0;
            transform: translateX(0) translateY(-150px);
          }
          22% {
            opacity: 0.15;
          }
          78% {
            opacity: 0.15;
          }
          100% {
            opacity: 0;
            transform: translateX(120px) translateY(250px);
          }
        }

        @keyframes lineFlow5 {
          0% {
            opacity: 0;
            transform: translateX(-120px) translateY(0);
          }
          16% {
            opacity: 0.15;
          }
          84% {
            opacity: 0.15;
          }
          100% {
            opacity: 0;
            transform: translateX(-350px) translateY(-100px);
          }
        }

        /* Icon fade in/out animation */
        @keyframes iconFade {
          0%, 100% {
            opacity: 0;
          }
          10%, 90% {
            opacity: 0.15;
          }
        }

        .animate-line-1 {
          animation: lineFlow1 28s ease-in-out infinite;
          animation-delay: 0s;
        }

        .animate-line-2 {
          animation: lineFlow2 32s ease-in-out infinite;
          animation-delay: 6s;
        }

        .animate-line-3 {
          animation: lineFlow3 30s ease-in-out infinite;
          animation-delay: 12s;
        }

        .animate-line-4 {
          animation: lineFlow4 34s ease-in-out infinite;
          animation-delay: 4s;
        }

        .animate-line-5 {
          animation: lineFlow5 26s ease-in-out infinite;
          animation-delay: 15s;
        }

        .icon-motion {
          animation: iconFade 28s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default AnimatedBackground;
